// ContactUsSection.jsx
import React from "react";
import "./ContactUsSection.css";
import { motion } from "framer-motion";

const ContactUsSection = () => {
  return (
    <section className="contact-section">

      <motion.div
        className="container"
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.3 }}
      >
        <h2 className="section-title-contact">Contact Us</h2>
        <p className="intro-text">
          If you need our services, please do not hesitate to contact us.<br />
          Email us for general queries, including marketing and partnership opportunities.
        </p>

        <div className="email-container">
          <a href="mailto:info@spacetimeai.com" className="email-link">
            info@spacetimeai.com
          </a>
        </div>
      </motion.div>
      
    </section>
  );
};

export default ContactUsSection;